import { FC } from "react"

interface Props {
  icon?: string
  title: string
  separator?: boolean
}

const SubSectionHeader: FC<Props> = ({icon, title, separator = true}: Props) => {
  return (
    <>
      {separator && (<div className='separator mb-5'></div>)}
      <div className='d-flex flex-column mb-5'>
        <span className='fs-5 fw-bolder'>{title}</span>
      </div>
    </>
  )
}

export {SubSectionHeader}
